import { some, sumBy } from 'lodash-es';
import { Basket, BasketItem } from '../client/src';
import { ApiError, DDAccountVerifyResponse } from '../client/src';

export const calculateDirectDebitAmount = (basket?: Basket): number => {
  const subscriptionItems =
    basket?.basketItems?.filter((item: BasketItem) => item.isDirectDebit) || [];
  return sumBy(subscriptionItems, (item: BasketItem) => item.toPayPrice);
};

export const hasDirectDebit = (basket?: Basket): boolean => {
  return some(basket?.basketItems || [], (item) => item.isDirectDebit);
};

export const directDebitIsValid = ({
  directDebitResponse,
  error,
}: {
  directDebitResponse: DDAccountVerifyResponse | undefined;
  error: string | ApiError | undefined;
}) => {
  if (!directDebitResponse) {
    return undefined;
  }

  return (
    directDebitResponse.valid === 'Valid' &&
    (error === undefined || error === '')
  );
};
